import * as yup from 'yup'

export const schemaCreateCreditTransactionModal = yup.object().shape({
    credit_id: yup.number().required(),
    credit_transaction_amount: yup.number().required(),
    credit_transaction_note: yup.string().required(),
    credit_transaction_type: yup.string().required(),
})
